import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-arrow-left",
  "use": "icon-cl-arrow-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-arrow-left\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.707 12.707a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L7.414 8l3.293 3.293a1 1 0 0 1 0 1.414Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol